import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { toggleInObject } from '@elliemae/ds-utilities/utils';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var checkAllRowsSelected = function checkAllRowsSelected(rows, selectedRows) {
  if (rows.length && selectedRows.length === rows.length) return true;
  if (selectedRows.length) return 'mixed';
  return false;
};
var toggleSelectAll = function toggleSelectAll(rows, checked) {
  return !checked ? {} : rows.reduce(function (nextSelRows, row) {
    return toggleInObject(nextSelRows, row.id, true);
  }, {});
};
var toggleSingleSelectable = function toggleSingleSelectable(selectedRows, id) {
  return !selectedRows[id] ? toggleInObject({}, id, true) : {};
};

var mergeSelectedToMetaData = function mergeSelectedToMetaData(selected) {
  return function (row) {
    return _objectSpread(_objectSpread({}, row), {}, {
      'metaData.selected': selected
    });
  };
};

var selectSingleRow = function selectSingleRow(rows, filter) {
  return rows.map(function (row) {
    return mergeSelectedToMetaData(filter(row))(row);
  });
};
var selectMultipleRow = function selectMultipleRow(rows, isRowSelectedPredicate) {
  return rows.map(function (row) {
    return mergeSelectedToMetaData(isRowSelectedPredicate(row))(row);
  });
};

export { checkAllRowsSelected, selectMultipleRow, selectSingleRow, toggleSelectAll, toggleSingleSelectable };
//# sourceMappingURL=helper.js.map
